/** Fallback link: a link that does not respond to clicks but still works as a link for middle clicks (open in new tab) and other purposes; useful for accessibility and SEO */
export default function FallbackLink({ children, to = null }) {
    return !to ? children : (
        <a href={to} onClick={ e => e.preventDefault() }>
            {children}
        </a>
    );
}